'use client';

import { queryOptions, useSuspenseQuery, UseSuspenseQueryResult } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { pdpIntroductionOptions } from '@/api/queries/pdpIntroduction';
import { MetaDataParams, PdpIntroductionDTO } from '@/types/models';
export function usePdpIntroduction(): UseSuspenseQueryResult<PdpIntroductionDTO & {
  id: string;
}> {
  const params = useParams<MetaDataParams>();
  const id = params.slug?.[0] || params.id;
  return useSuspenseQuery(queryOptions(pdpIntroductionOptions(id as string)));
}